module.exports = __webpack_public_path__ + "static/media/logo_rw_small.ff90ed31.svg";